import type { ContactMatches, JobDetails } from '@seek/ca-graphql-schema/types';

import { filterBlanks } from '../utils/filterBlanks';

const flattenContactMatch = ({ type }: ContactMatches) => type;

export const mapJob = (jobDetails: JobDetails) => {
  const {
    companyProfile,
    job: {
      advertiser,
      contactMatches,
      id: jobId,
      isLinkOut: jobIsLinkOut,
      title: jobTitle,
      tracking,
      salary,
      status,
    },
  } = jobDetails;

  const { id: seekAdvertiserId, name: advertiserName } = advertiser;

  const {
    adProductType: jobListingType,
    classificationInfo,
    hasRoleRequirements: jobHasRoleRequirements,
    isPrivateAdvertiser,
    locationInfo,
    workTypeIds,
    postedTime,
  } = tracking ?? {};

  return filterBlanks({
    seekAdvertiserId,
    advertiserName,
    companyId: companyProfile?.id,
    companyName: companyProfile?.name,
    companyRating:
      companyProfile?.reviewsSummary?.overallRating?.value?.toString(),
    isPrivateAdvertiser,
    jobId,
    jobTitle,
    jobIsLinkOut,
    jobHasRoleRequirements,
    jobContacts: contactMatches?.map(flattenContactMatch),
    jobStatus: status?.toLowerCase(),
    jobSalary: salary?.label,
    jobListingType,
    jobPostedTime: postedTime,
    jobArea: locationInfo?.area,
    jobLocation: locationInfo?.location,
    jobWorkTypeIds: workTypeIds,
    jobWhereId: locationInfo?.locationIds?.[0] ?? undefined,
    jobClassification: classificationInfo?.classification,
    jobClassificationId: classificationInfo?.classificationId,
    jobSubClassification: classificationInfo?.subClassification,
    jobSubClassificationId: classificationInfo?.subClassificationId,
  });
};
